(function () {
  // Read more for collection_description
  var c_description = document.querySelector(".collection-hero__description");
  if (c_description) {
    var button = document.querySelector(".expand-btn_collection");
    // console.log(c_description.scrollHeight);
    if (c_description.scrollHeight > 68) {
      button.style.display = "inline-block";
      button.addEventListener("click", function () {
        c_description.classList.toggle("expanded");
        if (c_description.classList.contains("expanded")) {
          button.textContent = "Read less";
        } else {
          button.textContent = "Read more";
        }
      });
    } else {
      button.style.display = "none";
    }
  }

  // Read more for product_collection
  var p_description = document.querySelector(".product__description");
  if (p_description) {
    var button = document.querySelector(".expand-btn_product");
    // console.log(description.scrollHeight);
    if (p_description.scrollHeight > 108) {
      button.style.display = "inline-block";
      button.addEventListener("click", function () {
        p_description.classList.toggle("expanded");
        if (p_description.classList.contains("expanded")) {
          button.textContent = "Read less";
        } else {
          button.textContent = "Read more";
        }
      });
    } else {
      button.style.display = "none";
    }
  }

  // Mobile footer
  var acc = document.getElementsByClassName("custom-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      var panel = this.nextElementSibling;
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        panel.style.maxHeight = null;
      } else {
        var active = document.querySelectorAll(".custom-accordion.active");
        for (var j = 0; j < active.length; j++) {
          active[j].classList.remove("active");
          active[j].nextElementSibling.style.maxHeight = null;
        }
        // Activate the clicked accordion
        this.classList.add("active");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  // Hide Log In

  // Adding custom class to sections
  var elements = [
    {
      selectors: [
        "#shopify-section-template--18097926275239__multicolumn_eiaB3F",
        "#shopify-section-template--23188682146086__multicolumn_HqjRFe",
      ],
      classes: ["card-popular_categories"],
    },
    {
      selectors: [
        "#shopify-section-template--18097926275239__multicolumn_ad3rih",
        "#shopify-section-template--18097926275239__multicolumn_ENAemt",
        "#shopify-section-template--18097926602919__multicolumn_yLB6qj",
        "#shopify-section-template--23188682146086__multicolumn_hQVcmr",
      ],
      classes: ["card-latest_deals"],
    },
    {
      selectors: [
        "#shopify-section-template--18112434307239__multicolumn_xf8Vyz",
      ],
      classes: ["image-carousels"],
    },
    {
      selectors: [
        "#shopify-section-template--18112434307239__multicolumn_xf8Vyz",
      ],
      classes: ["combination-carousels"],
    },
    {
      selectors: [
        "#shopify-section-template--23188682146086__collection_list_6tCazD",
      ],
      classes: ["landing-collection"],
    },
    {
      selectors: ["#shopify-section-template--23188682146086__main"],
      classes: ["oneclub-main"],
    },
    {
      selectors: [
      ],
      classes: ["brands-wrapper"],
    },
    {
      selectors: [
        "#shopify-section-template--18112434274471__multicolumn_CMm43H",
        "#shopify-section-template--18097925882023__multicolumn_XjHwUE",
      ],
      classes: ["concern-carousels"],
    },
    {
      selectors: [
        "#shopify-section-template--18097925882023__multicolumn_XjHwUE",
      ],
      classes: ["pnf-layout"],
    },
    {
      selectors: [
        "#shopify-section-template--23188682146086__image_banner_PEXEza",
        "#shopify-section-template--23188682146086__image_banner_dR3w48",
        "#shopify-section-template--23188682146086__image_banner_hWwbh4",
        "#shopify-section-template--23188682146086__image_banner_wEeLft",
        "#shopify-section-template--23188682146086__image_banner_wEeLft",
        "#shopify-section-template--23188682146086__image_banner_CtkLgF",
        "#shopify-section-template--23188682146086__image_banner_Dw6ceR",
        "#shopify-section-template--23188682146086__image_banner_RbEgxA",
      ],
      classes: ["campaign-content-wrapper"],
    },
  ];
  elements.forEach(function (item) {
    item.selectors.forEach(function (selector) {
      var element = document.querySelector(selector);
      if (element) {
        item.classes.forEach(function (cls) {
          element.classList.add(cls);
        });
      }
    });
  });

  // Countdown timer
  var saleTimerElement = document.getElementById("saleTimers");
  if (saleTimerElement) {
    var countDownDate = new Date("Oct 9, 2024 23:59:59").getTime();
    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Sale start text here
      var timerMessage = "FREE SHIPPING OVER $1000 T&C's apply.*";

      var wrappedDigits =
        "<div class='timer-boxes'>" +
        wrapDigits(days) +
        " : " +
        wrapDigits(hours) +
        " : " +
        wrapDigits(minutes) +
        " : " +
        wrapDigits(seconds) +
        "</div>";
      document.getElementById("saleTimer").innerHTML =
        timerMessage +
        wrappedDigits +
        '<button style="background-color:#cbfe33;color:#f42736;border-radius:2px;border:none;padding:4px;font-weight:600">CODE: FREESHIP</button>';

      if (!saleTimer.classList.contains("visible")) {
        saleTimer.classList.add("visible");
      }

      // Sale end text here
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("saleTimer").classList.add("countdown-ended");
        document.getElementById("saleTimer").innerHTML =
          "THE LATEST DEALS AT YOUR FINGER TIPS! <a href='https://qrco.de/beSZnx' class='sticky-cta'>Get App</a>";
        var ctaElement = document.querySelector(".timer-cta");
        if (ctaElement) {
          ctaElement.parentNode.removeChild(ctaElement);
        }
        var timerWrapper = document.querySelector(".timer-wrapper");
        if (timerWrapper) {
          timerWrapper.classList.add("countdown-ended");
        }
      }
    }, 1000);

    function wrapDigits(number) {
      var digitString = formatDigits(number);
      var wrappedDigits = Array.from(digitString, function (digit) {
        return "<span class='timer-box'>" + digit + "</span>";
      });
      return wrappedDigits.join("");
    }
    function formatDigits(number) {
      return number < 10 ? "0" + number : number.toString();
    }
  }

  // Ticker
  const scrollers = document.querySelectorAll(".scroller");

  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
  }

  function addAnimation() {
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".scroller__inner");
      const scrollerContent = Array.from(scrollerInner.children);
      let contentWidth = scrollerInner.scrollWidth;
      const scrollerWidth = scroller.clientWidth;
      const minimumWidth = scrollerWidth * 3;
      while (contentWidth < minimumWidth) {
        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          scrollerInner.appendChild(duplicatedItem);
        });
        contentWidth = scrollerInner.scrollWidth;
      }
    });
  }

  // Main function ends

  // Overlay
  document.addEventListener("DOMContentLoaded", () => {
    const searchCustom = document.querySelector(".search-custom");
    const searchInput = searchCustom.querySelector(".field__input");
    const overlay = searchCustom.querySelector(".overlay");

    searchInput.addEventListener("focus", () => {
      overlay.classList.add("active");
    });

    searchInput.addEventListener("blur", (event) => {
      setTimeout(() => {
        if (!searchCustom.contains(document.activeElement)) {
          overlay.classList.remove("active");
        }
      }, 100);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && overlay.classList.contains("active")) {
        overlay.classList.remove("active");
        searchInput.blur();
      }
    });
  });
})();

if (document.getElementById("openModal")) {
  // Get the modal and the text to click
  var modal = document.getElementById("modal");
  var clickText = document.getElementById("openModal");

  // When the user clicks the text, open the modal
  clickText.onclick = function () {
    // console.log("Hey");
    modal.style.display = "block";
    modal.classList.add("open");
  };

  // When the user clicks on the close button or outside the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
      modal.classList.remove("open");
    }
  };

  var closeBtn = document.getElementsByClassName("close")[0];
  closeBtn.onclick = function () {
    modal.style.display = "none";
  };
}

function addHoverListenersToCustomElement(tagName, onHover, onLeave) {
  const elements = document.querySelectorAll(tagName);
  elements.forEach((element) => {
    element.addEventListener("mouseover", onHover);
    element.addEventListener("mouseout", onLeave);
  });
}

function handleHover(event) {
  const detailsElement = event.currentTarget.querySelector("details");
  if (detailsElement) {
    detailsElement.setAttribute("open", "");
  }
}

function handleLeave(event) {
  const detailsElement = event.currentTarget.querySelector("details");
  if (detailsElement) {
    detailsElement.removeAttribute("open");
  }
}

addHoverListenersToCustomElement("header-menu", handleHover, handleLeave);

document.addEventListener('DOMContentLoaded', function () {
  const item1 = document.querySelector('.thumbnail-list__item[data-media-position="1"]');
  const item2 = document.querySelector('.thumbnail-list__item[data-media-position="2"]');

  if (item1 && item1.classList.contains('thumbnail-list_item--variant') && item2) {
    const button = item2.querySelector('button');
    if (button) {
      button.click();
    }
  }
});